import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

export interface DialogData {
  selectedObjects: any[];
  dialogTitle: string;
  selectionEntity: any;
  displayedColumns: string[];
  selectedObject: any;
  excludedId: number;
  selectionMode: string;

}

@Component({
    selector: 'app-select-dialog',
    templateUrl: './select-dialog.component.html',
    styleUrl: './select-dialog.component.scss',
    standalone: false
})
export class SelectDialogComponent {


  selectionMode: string;
  displayedColumns: string[];

  selectedObject: any;
  selectedObjects: any[];
  selectionClear: boolean = false;
  selectionEntity: any

  dialogTitle: string
  excludedId: number

  constructor(@Inject(MAT_DIALOG_DATA) public injectedData: DialogData,
              private dialogRef: MatDialogRef<SelectDialogComponent>) {
    this.selectionMode = injectedData.selectionMode;
    this.excludedId = injectedData.excludedId;

    if (this.selectionMode === 'single-select') {
      this.selectedObject = injectedData.selectedObject;
      if (Array.isArray(this.selectedObject)) {
        this.selectedObject = this.selectedObject[0];
      }
    }

    if (this.selectionMode === 'multi-select') {
      this.selectedObjects = injectedData.selectedObjects;
      if (this.selectedObjects == null) {
        this.selectedObjects = [];
      }
    }
    this.displayedColumns = injectedData.displayedColumns;
    this.selectionEntity = injectedData.selectionEntity;
    this.dialogTitle = injectedData.dialogTitle;
  }

  closeDialog() {
    if (this.selectionMode === 'single-select') {
      this.dialogRef.close([this.selectedObject]);
    }

    if (this.selectionMode === 'multi-select') {
      this.dialogRef.close(this.selectedObjects);
    }
  }

  returnInitialData() {
    this.dialogRef.close();
  }

  handleSelectedObjectOutput($event: any) {
    if ($event.type === 'single') {
      this.selectedObject = $event.data
    } else if ($event.type === 'multi') {
      this.selectedObjects = $event.data
    }
  }


}
